import { NgModule, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { Component } from '@angular/core';
import { NavParams, ModalController } from '@ionic/angular';
import { IonicModule } from '@ionic/angular';
import { ModalDetallePage } from './modal-detalle.page';
import {ServiciodepedidovigenteService} from '../serviciodepedidovigente.service'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';


const routes: Routes = [
  {
    path: '',
    component: ModalDetallePage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ModalDetallePage]
})
export class ModalDetallePageModule{

  




}
